import type { IconNode } from '../types';

/**
 * @name earbuds-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTB2OWEyIDIgMCAwMS00IDB2LThhNSA1IDAgMDEtMy43NS0xLjY5M0ExIDEgMCAwMTIgOC42NDZWNS4zNTRhMSAxIDAgMDEuMjUtLjY2MSA1IDUgMCAwMTEuMzU5LTEuMDg0IiAvPgogIDxwYXRoIGQ9Ik0xNCAxNHY1YTIgMiA5MCAwMDQgMHYtMSIgLz4KICA8cGF0aCBkPSJNMTggMTIuMzQzVjExYTUgNSA5MCAwMDMuNzUtMS42OTMgMSAxIDkwIDAwLjI1LS42NjFWNS4zNTRhMSAxIDkwIDAwLS4yNS0uNjYxQTUgNSA5MCAwMDE4IDNhNCA0IDkwIDAwLTQgNHYxLjM0MyIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/earbuds-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const EarbudsOff: IconNode = [
  [
    'path',
    {
      d: 'M10 10v9a2 2 0 01-4 0v-8a5 5 0 01-3.75-1.693A1 1 0 012 8.646V5.354a1 1 0 01.25-.661 5 5 0 011.359-1.084',
    },
  ],
  ['path', { d: 'M14 14v5a2 2 90 004 0v-1' }],
  [
    'path',
    {
      d: 'M18 12.343V11a5 5 90 003.75-1.693 1 1 90 00.25-.661V5.354a1 1 90 00-.25-.661A5 5 90 0018 3a4 4 90 00-4 4v1.343',
    },
  ],
  ['path', { d: 'm2 2 20 20' }],
];

export default EarbudsOff;
